<script>
import appConfig from "@/app.config.json";
import Layout from "@/views/layouts/main.vue";
import {BIconCaretLeftFill, BIconCaretRightFill, BIconExclamationCircleFill} from 'bootstrap-vue'
import systemCode from "@/mixins/systemCode";
import router from "@/mixins/router";
import listDailyReport from "@/mixins/daily_reports/listDailyReport";
import ModalWorkHistorySP from "@/views/pages/daily_reports/modals/sp/ModalWorkHistory.vue";
import VendorsName from '@/views/pages/daily_reports/components/vendors_name.vue';
import VendorsTel from '@/views/pages/daily_reports/components/vendors_tel.vue';
import VendorsAddress from '@/views/pages/daily_reports/components/vendors_address.vue';
import VendorSitesName from '@/views/pages/daily_reports/components/vendor_sites_name.vue';
import VendorSitesTel from '@/views/pages/daily_reports/components/vendor_sites_tel.vue';
import VendorSitesAddress from '@/views/pages/daily_reports/components/vendor_sites_address.vue';
import Cars from '@/views/pages/daily_reports/components/cars.vue';
import Staffs from '@/views/pages/daily_reports/components/staffs.vue';
import DatePicker from "vue2-datepicker";

export default {
  name: "ListDailyReportSP",
  page: {
    title: "作業日報一覧（運搬）",
    meta: [{name: "description", content: appConfig.description}]
  },
  mixins: [systemCode, router, listDailyReport],
  components: {
    Layout,
    BIconExclamationCircleFill,
    BIconCaretRightFill,
    BIconCaretLeftFill,
    ModalWorkHistorySP,
    VendorsName,
    VendorsTel,
    VendorsAddress,
    VendorSitesName,
    VendorSitesTel,
    VendorSitesAddress,
    Cars,
    Staffs,
    DatePicker
  },
  methods: {
    getDischargerAddress(item) {
      return this.$helpers.formatZipCode(item.work_order_json?.case?.discharger?.zip).concat(
        item.work_order_json.case.discharger?.address_1 === null ? '' : item.work_order_json.case.discharger?.address_1,
        item.work_order_json.case.discharger?.address_2 === null ? '' : item.work_order_json.case.discharger?.address_2,
        item.work_order_json.case.discharger?.address_3 === null ? '' : item.work_order_json.case.discharger?.address_3,
        item.work_order_json.case.discharger?.address_4 === null ? '' : item.work_order_json.case.discharger?.address_4
      );
    },
    onChangeSelectedDate(){
      this.getData();
    },
  }
};
</script>
<template>
  <Layout>
    <div class="list-daily-report-sp">
      <ModalWorkHistorySP
        ref="workHistory"
      />
      <b-card>
        <div class="d-flex justify-content-end mb-1">
          <b-button
            variant="primary"
            size="md"
            @click="redirectRoute('factories',{},{ fromMenu: 0, date: filters.date })"
            v-if="showSelectFactory"
          >
            工場選択
          </b-button>
        </div>
        <div class="d-flex justify-content-center mb-3">
          <div>
          <span class="h1 mb-2 cursor-pointer">
            <b-icon-caret-left-fill variant="primary" @click="prevDate" v-if="showPrev"/>
          </span>
          </div>
          <div>
            <span>
            <date-picker
                  lang="ja"
                  :clearable="false"
                  placeholder="YYYY-MM-DD"
                  format="YYYY-MM-DD（ddd）"
                  value-type="YYYY-MM-DD"
                  position="left"
                  type="date"
                  v-model="filters.date"
                  @change="onChangeSelectedDate"
                >
          </date-picker>
          </span>
          </div>
          <div>
          <span class="h1 mb-2 cursor-pointer">
            <b-icon-caret-right-fill variant="primary" @click="nextDate" v-if="showNext"/>
          </span>
          </div>
          </div>
      </b-card>
      <b-card v-for="(item, index) in data" :key="index">
        <div class="mb-3 align-items-center d-flex gap-2 flex-wrap" :id="`schedule_${index + 1}`">
          <div class="d-flex w-50">
            <span
              class="badge mr-0dot5"
              :class="item.schedule && item.schedule.is_mixed_loading_kbn ? 'bg-primary' : 'orange'"
            >
              {{
                item.schedule && item.schedule.is_mixed_loading_kbn ? "合積" : "単独"
              }}
            </span>
            <span
              class="badge mr-0dot5"
              :style="{'background-color': colorBadge5(item)}"
            >{{ showBadge5(item) }}</span>
            <span
              class="badge"
              :style="{ backgroundColor: getColorBadge6(item, index) + '!important', color:getColorTextBadge6(item, index)}"
            >{{ showBadge6(item) }}</span>
          </div>
          <div>
            <template v-if="showDateAlert(item)">
                <span class="font-size-20">
                  <b-icon-exclamation-circle-fill variant="danger"/>
                </span>
              <span>
                  {{ formatDateAlert(item, "sp") }}
                </span>
            </template>
          </div>
        </div>
        <div class="mb-3">
          <div class="wrapC">
            <div class="labelC bg-success">No</div>
            <div class="contentC">{{ index + 1 }}</div>
          </div>
          <div class="wrapC fw-bold">
            <div class="labelC bg-success">作業時間</div>
            <div class="contentC ">
              <span v-if="item.schedule">{{ formatHour(item.schedule.start_datetime) }}</span>
              <span class="m-2">～</span>
              <span v-if="item.schedule">{{ formatHour(item.schedule.end_datetime) }}</span>
            </div>
          </div>
          <div class="wrapC">
            <div class="labelC bg-success">受付番号</div>
            <div class="contentC"><span>{{ item.schedule_id }}</span></div>
          </div>
          <div class="wrapC">
            <div class="labelC bg-success">作業指示名</div>
            <div class="contentC">
              <router-link
                class="text-decoration-underline"
                v-if="item.work_order_json"
                :to="{ name: 'projects.sales.instructions.detail',
                    params: { id: item.work_order_json.case_id, work_order_id: item.work_order_json.id  },
                    query: { readonly: true, daily_report_id: item.id }
              }"
              >
                {{ item.work_order_json.name }}
              </router-link>
            </div>
          </div>
          <div class="wrapC">
            <div class="labelC bg-success">排出事業者</div>
            <div class="contentC">
              <span
                v-if="item.work_order_json &&
                item.work_order_json.case &&
                item.work_order_json.case.discharger"
              >
                {{
                  item.work_order_json.case.discharger.name
                }}
              </span>
            </div>
          </div>
          <div class="wrapC">
            <div class="labelC bg-success">排出事業者住所</div>
            <div class="contentC">
              <span>
                {{ getDischargerAddress(item) }}
              </span>
            </div>
          </div>
          <div class="wrapC">
            <div class="labelC bg-success">排出事業者TEL</div>
            <div class="contentC">
              <span
                v-if="item.work_order_json &&
                item.work_order_json.case &&
                item.work_order_json.case.discharger"
              >
                {{
                  item.work_order_json.case.discharger.tel
                }}
              </span>
            </div>
          </div>
          <div class="wrapC">
            <div class="labelC bg-success">排出事業場</div>
            <div class="contentC">
              <span
                v-if="item.work_order_json &&
                item.work_order_json.case &&
                item.work_order_json.case.discharger_site"
              >
                {{
                  item.work_order_json.case.discharger_site.name
                }}
              </span>
            </div>
          </div>
          <div class="wrapC">
            <div class="labelC bg-success">排出事業場住所</div>
            <div class="contentC">
              <span
                v-if="item.work_order_json &&
                item.work_order_json.case &&
                item.work_order_json.case.discharger_site"
              >
                {{
                  $helpers.formatZipCode(item.work_order_json.case.discharger_site.zip)
                  + (item.work_order_json.case.discharger_site.address_1 === null ? '' : item.work_order_json.case.discharger_site.address_1)
                  + (item.work_order_json.case.discharger_site.address_2 === null ? '' : item.work_order_json.case.discharger_site.address_2)
                  + (item.work_order_json.case.discharger_site.address_3 === null ? '' : item.work_order_json.case.discharger_site.address_3)
                  + (item.work_order_json.case.discharger_site.address_4 === null ? '' : item.work_order_json.case.discharger_site.address_4)
                }}
              </span>
            </div>
          </div>
          <div class="wrapC">
            <div class="labelC bg-success">排出事業場TEL</div>
            <div class="contentC">
              <span
                v-if="item.work_order_json &&
                item.work_order_json.case &&
                item.work_order_json.case.discharger_site"
              >
                {{
                  item.work_order_json.case.discharger_site.tel
                }}
              </span>
            </div>
          </div>
          <div class="wrapC" v-if="showProcessCompany(item)">
            <div class="labelC bg-success">処分事業者</div>
            <div class="contentC">
              <div>
                <VendorsName
                  v-if="item.schedule && item.schedule.waste_or_services_by_schedule"
                  :wastes-or-service-by-schedule="item.schedule.waste_or_services_by_schedule"
                />
              </div>
            </div>
          </div>
          <div class="wrapC" v-if="showProcessCompany(item)">
            <div class="labelC bg-success">処分事業者住所</div>
            <div class="contentC">
              <div>
                <VendorsAddress
                  v-if="item.schedule && item.schedule.waste_or_services_by_schedule"
                  :wastes-or-service-by-schedule="item.schedule.waste_or_services_by_schedule"
                />
              </div>
            </div>
          </div>
          <div class="wrapC" v-if="showProcessCompany(item)">
            <div class="labelC bg-success">処分事業者TEL</div>
            <div class="contentC">
              <div>
                <VendorsTel
                  v-if="item.schedule && item.schedule.waste_or_services_by_schedule"
                  :wastes-or-service-by-schedule="item.schedule.waste_or_services_by_schedule"
                />
              </div>
            </div>
          </div>
          <div class="wrapC" v-if="showProcessCompany(item)">
            <div class="labelC bg-success">処分事業場</div>
            <div class="contentC">
              <VendorSitesName
                v-if="item.schedule && item.schedule.waste_or_services_by_schedule"
                :wastes-or-service-by-schedule="item.schedule.waste_or_services_by_schedule"
              />
            </div>
          </div>
          <div class="wrapC" v-if="showProcessCompany(item)">
            <div class="labelC bg-success">処分事業場住所</div>
            <div class="contentC">
              <VendorSitesAddress
                v-if="item.schedule && item.schedule.waste_or_services_by_schedule"
                :wastes-or-service-by-schedule="item.schedule.waste_or_services_by_schedule"
              />
            </div>
          </div>
          <div class="wrapC" v-if="showProcessCompany(item)">
            <div class="labelC bg-success">処分事業場TEL</div>
            <div class="contentC">
              <VendorSitesTel
                v-if="item.schedule && item.schedule.waste_or_services_by_schedule"
                :wastes-or-service-by-schedule="item.schedule.waste_or_services_by_schedule"
              />
            </div>
          </div>
          <div class="wrapC" v-if="item.schedule && item.schedule.assigned_cars_by_schedule">
            <div class="labelC bg-success">車両</div>
            <div class="contentC">
              <Cars
                v-if="item.schedule && item.schedule.assigned_cars_by_schedule"
                :schedule="item.schedule"
              />
            </div>
          </div>
          <div class="wrapC" v-if="item.schedule && item.schedule.assigned_staffs_by_schedule"">
            <div class="labelC bg-success">従業員</div>
            <div class="contentC">
              <Staffs
                v-if="item.schedule && item.schedule.assigned_staffs_by_schedule"
                :schedule="item.schedule"
              />
            </div>
          </div>
          <div class="wrapC" v-if="showProcessCompany(item)">
            <div class="labelC bg-success">作業者向け備考欄</div>
            <div class="contentC"><span
              v-if="item.schedule && item.schedule.waste_or_services_by_schedule"
              v-html="getCommentToUser(item.schedule.waste_or_services_by_schedule)">
            </span></div>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <button
            class="btn btn-primary waves-effect waves-light mr-0dot5"
            @click="
              redirectRoute(
                'daily_reports.input',
                { id: item.id },
                { index: index + 1, date: filters.date }
              )
            "
          >
            日報入力
          </button>
          <button
            @click="openworkHistoryModal(item)"
            class="btn btn-primary waves-effect waves-light"
          >
            <i class="fas fa-history"></i> 作業履歴
          </button>
        </div>
      </b-card>
    </div>
  </Layout>
</template>
<style lang="scss" scoped>

.card-body {
  padding: 1.25rem 0.5rem !important;
}

.labelC {
  padding: 10px 7px;
  font-weight: bold;
  min-width: 110px;
  border-right: 1px solid #eff2f7;
}

.contentC {
  padding: 10px 7px;
  width: 100%;
}

.wrapC {
  display: flex;
  border-top: 1px solid #eff2f7;
  border-left: 1px solid #eff2f7;
  border-right: 1px solid #eff2f7;
}

.wrapC:last-child {
  border-bottom: 1px solid #eff2f7;
}

.badge {
  width: 100%;
  padding: 7px;
}

.orange {
  background: #d1885d !important;
}

.grey {
  background: #f8f9fa;
}

.mr-0dot5 {
  margin-right: 5px;
}

.content-area {
  padding: 0px;
  background: unset;

}
</style>
